// * IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint-disable */
export const VERSION = {
  "dirty": false,
  "raw": "a8e8436",
  "hash": "a8e8436",
  "distance": null,
  "tag": null,
  "semver": null,
  "suffix": "a8e8436",
  "semverString": null,
  "version": "0.0.1"
};
/* eslint-enable */
